import { match } from 'path-to-regexp'
import React, { useEffect, useState } from 'react'
import StyleWrapper from 'common/components/StyleWrapper'
import * as types from 'common/types'
import CustomLoginInterface from 'common/types/entities/CustomLoginInterface'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import useManagement, { selectors } from 'publisher/hooks/useManagement'
import { getUserData } from 'src/publisher/api/user-data-api'

type NewCustomLoginProps = {
  entity: CustomLoginInterface
}

function NewCustomLogin({ entity }: NewCustomLoginProps) {
  const isPreview = useManagement(selectors.isPreviewMode)
  const [mode, setMode] = useState(isPreview ? [entity.childIds[0]] : null)

  useEffect(() => {
    const checkPattern = (uri: string) => match(uri)(window.location.pathname)
    if (
      checkPattern('/dashboard/:locale/login') ||
      checkPattern('/:locale/login') ||
      checkPattern('/login')
    ) {
      setMode([entity.childIds[0]])
    } else if (
      checkPattern('/dashboard/:locale/registration/set-password/:token') ||
      checkPattern('/:locale/register/confirm/:token') ||
      checkPattern('/register/confirm/:token')
    ) {
      setMode([entity.childIds[1]])
    } else if (
      checkPattern('/dashboard/:locale/resetting/request') ||
      checkPattern('/:locale/restore-password') ||
      checkPattern('/reset-password')
    ) {
      setMode([entity.childIds[2]])
    } else if (
      checkPattern('/dashboard/:locale/resetting/reset/:token') ||
      checkPattern('/:locale/reset-password/:token') ||
      checkPattern('/reset-password/:token')
    )
      setMode([entity.childIds[3]])
  }, [entity.childIds])

  useEffect(() => {
    const load = async () => {
      const response = await getUserData()

      if (response.data?.hasWhiteLabel && response.data?.id) {
        window.location.href = '/dashboard'
      }
      if (response.data?.id) {
        window.location.href = '/school'
      }
    }

    load()
  }, [])

  return (
    <StyleWrapper
      desktop={entity.appearance.desktop}
      mobile={entity.appearance.mobile}
    >
      {mode && <BaseNodeChildren childIds={mode} />}
    </StyleWrapper>
  )
}

NewCustomLogin.propTypes = {
  entity: types.entity.isRequired,
}

export default NewCustomLogin
